module.exports = __webpack_public_path__ + "static/police-indianapolis-743f16f92c1ace07ae7f4a87d03a1535.gif";